import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { wmBase } from "@/widgetMenu/wmBase";

type OptionsList = widgetOption<object>[];

export class WmAddText extends wmBase {
    constructor(options: OptionsList) {
        super();
        this.options = options;
    }

    build() {
        if (this.options.length !== 1) {
            return "";
        }

        return `
            <div class="wm_addText">
               <svg width="23" height="17" viewBox="0 0 23 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.66675 1.09524C7.66675 1.70012 8.1571 2.19048 8.76199 2.19048H14.2382V15.3333C14.2382 15.9382 14.7285 16.4286 15.3334 16.4286C15.9383 16.4286 16.4287 15.9382 16.4287 15.3333V2.19048H21.9048C22.5097 2.19048 23.0001 1.70012 23.0001 1.09524C23.0001 0.490355 22.5097 0 21.9048 0H8.76199C8.1571 0 7.66675 0.490355 7.66675 1.09524Z" fill="black"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.28571 8.76228V6.5718C3.28571 5.96692 3.77607 5.47656 4.38095 5.47656C4.98584 5.47656 5.47619 5.96692 5.47619 6.5718V8.76228H7.66667C8.27155 8.76228 8.7619 9.25263 8.7619 9.85751C8.7619 10.4624 8.27155 10.9528 7.66667 10.9528H5.47619V13.1432C5.47619 13.7481 4.98584 14.2385 4.38095 14.2385C3.77607 14.2385 3.28571 13.7481 3.28571 13.1432V10.9528H1.09524C0.490355 10.9528 0 10.4624 0 9.85751C0 9.25263 0.490355 8.76228 1.09524 8.76228H3.28571Z" fill="black"/>
                </svg>
            </div>
        `;
    }

    init() {
        const item = document.querySelector(".wm_addText");
        item?.removeEventListener("click", this.itemClick, false);
        item?.addEventListener("click", this.itemClick, false);
    }

    itemClick = (e) => {
        const otherSubmenu = document.querySelector(".widgetSubMenu");
        if (otherSubmenu) {
            otherSubmenu.outerHTML = "";
        }
        this.applyValue(this.options, "", true, true);
    };

    name = "wm_addText";
    options: OptionsList = [];
}
